var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      ref: "site_button",
      staticClass: "site_button",
      class: [_vm.theme, _vm.type],
      attrs: {
        href: _vm.parsedLink ? _vm.parsedLink.url : null,
        target: _vm.parsedLink ? _vm.parsedLink.target : null,
      },
      on: {
        mouseenter: function ($event) {
          _vm.hovered = true
        },
        mouseleave: function ($event) {
          _vm.hovered = false
        },
      },
    },
    [
      _vm.type === "video"
        ? _c("video-icon", { staticClass: "video_icon" })
        : _vm._e(),
      _vm._v(" "),
      _c("span", {
        domProps: {
          innerHTML: _vm._s(
            _vm.button_label ? _vm.button_label : _vm.parsedLink.title
          ),
        },
      }),
      _vm._v(" "),
      _vm.parsedLink.target === "_blank" ||
      _vm.button_link.target === "_blank" ||
      _vm.target === "_blank"
        ? _c("external-link", { staticClass: "external_link_icon" })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }